module.exports = __webpack_public_path__ + "static/img/logo2.184a11c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo2.png
// module id = qvJq
// module chunks = 13